import {
  formatUtcDate,
  getTradingFlowId,
  getYMDStartDate,
  getYMDEndDate,
  forcedCloseConvertFromCheckbox,
} from '@/utils/searchUtil.js';

export function convertFilterFormToQuery(f) {
  // SelectableTradingList側のキー
  const flowUpdateDateFrom = f.flowUpdateDatetime
    ? formatUtcDate(f.flowUpdateDatetime[0])
    : null;
  const flowUpdateDateTo = f.flowUpdateDatetime?.[1]
    ? formatUtcDate(f.flowUpdateDatetime[1]).replace('00Z', '59Z')
    : null;

  // TradingFlowList側のキー
  const lastUpdateDateFrom = f.lastUpdateDatetime
    ? formatUtcDate(f.lastUpdateDatetime[0])
    : null;
  const lastUpdateDateTo = f.lastUpdateDatetime?.[1]
    ? formatUtcDate(f.lastUpdateDatetime[1]).replace('00Z', '59Z')
    : null;

  const query = {
    flowUpdateDateFrom: flowUpdateDateFrom || lastUpdateDateFrom,
    flowUpdateDateTo: flowUpdateDateTo || lastUpdateDateTo,
    tradingProgressStatus: f.tradingProgressStatus,
    tradingName: f.tradingName,
    flowName: f.flowName,
    invoiceNo: f.invoiceNo,
    flowCreateDateFrom: f.flowCreateDatetime
      ? formatUtcDate(f.flowCreateDatetime[0])
      : null,
    flowCreateDateTo: f.flowCreateDatetime?.[1]
      ? formatUtcDate(f.flowCreateDatetime[1]).replace('00Z', '59Z')
      : null,
    fromSectionIds: f.fromSectionIds || null,
    toSectionIds: f.toSectionIds || null,
    // tradingId: getTradingFlowId(f.tradingFlowId)[0] || '',
    tradingId: f.tradingId,
    // tradingFlowId: getTradingFlowId(f.tradingFlowId)[1] || '',
    tradingFlowId: f.tradingFlowId,
    contractDateStartDate: getYMDStartDate(f.contractDate) || null,
    contractEndDate: getYMDEndDate(f.contractDate) || null,
    sellerName: f.sellerName || null,
    buyerName: f.buyerName || null,
    goodsName: f.goodsName || null,
    ownerSectionIds: f.ownerSectionIds || null,
    nameOfVessel: f.vesselName || null,
    blNo: f.blNo || null,
    vesselBookingNo: f.bookingNo || null,
    blDateFrom: getYMDStartDate(f.etdBlDate) || null,
    blDateTo: getYMDEndDate(f.etdBlDate) || null,
    dischargingCurrentEtaFrom: getYMDStartDate(f.currentEta) || null,
    dischargingCurrentEtaTo: getYMDEndDate(f.currentEta) || null,
    portOfLoadingName: f.portOfLoading || null,
    portOfDischargingName: f.portOfDischarging || null,
    imRequestDeclarationDateFrom:
      getYMDStartDate(f.imRequestDeclarationDate) || null,
    imRequestDeclarationDateTo:
      getYMDEndDate(f.imRequestDeclarationDate) || null,
    deliveryDateFrom: getYMDStartDate(f.deliveryDate) || null,
    deliveryDateTo: getYMDEndDate(f.deliveryDate) || null,
    devanningPlace: f.devanningPlace || null,
    warehouse: f.warehouse || null,
    freeTimeFrom: getYMDStartDate(f.freeTime) || null,
    freeTimeTo: getYMDEndDate(f.freeTime) || null,
    exRequestDeclarationDateFrom:
      getYMDStartDate(f.exRequestDeclarationDate) || null,
    exRequestDeclarationDateTo:
      getYMDEndDate(f.exRequestDeclarationDate) || null,
    vanningDateFrom: getYMDStartDate(f.vanningDate) || null,
    vanningDateTo: getYMDEndDate(f.vanningDate) || null,
    vanningPlace: f.vanningPlace || null,
    cyCutDateFrom: getYMDStartDate(f.cyCutDate) || null,
    cyCutDateTo: getYMDEndDate(f.cyCutDate) || null,
    poNo: f.poNo || null,
    loadingPortCurrentEtdFrom: getYMDStartDate(f.loadingPortCurrentEtd) || null,
    loadingPortCurrentEtdTo: getYMDEndDate(f.loadingPortCurrentEtd) || null,
    loadingPortAtdFrom: getYMDStartDate(f.loadingPortAtd) || null,
    loadingPortAtdTo: getYMDEndDate(f.loadingPortAtd) || null,
    dischargingAtaFrom: getYMDStartDate(f.dischargingAta) || null,
    dischargingAtaTo: getYMDEndDate(f.dischargingAta) || null,
    scheduledDeliveryDateFrom: getYMDStartDate(f.scheduledDeliveryDate) || null,
    scheduledDeliveryDateTo: getYMDEndDate(f.scheduledDeliveryDate) || null,
    scheduledDevanningDateFrom: getYMDStartDate(f.scheduledDevanningDate) || null,
    scheduledDevanningDateTo: getYMDEndDate(f.scheduledDevanningDate) || null,
    modeOfTransportation: (f.modeOfTransportation === '' || f.modeOfTransportation === false || f.modeOfTransportation == null) ? null : f.modeOfTransportation, // 区分値のcodeに0が入る可能性あり
    typeOfServiceFrom: f.typeOfServiceFrom || null,
    hazardousFlag: (f.hazardousFlag === '' || f.hazardousFlag === false || f.hazardousFlag == null) ? null : f.hazardousFlag, // 区分値のcodeに0が入る可能性あり
    flowReference: f.flowReference || null,
    flowUserName: f.flowUserName || null,
    forcedClose: forcedCloseConvertFromCheckbox(f.forcedCloseIncludeHiddenFlow), // src\utils\searchUtil.jsの【取引一覧のforcedClose補足】参照。
  };

  return query;
}

export function convertSortEventToQuery(sortEvent) {
  if (!sortEvent || !sortEvent.prop || !sortEvent.order) {
    return {
      target: [],
      sortType: [],
    };
  }
  return {
    target: [sortEvent.prop],
    sortType: [sortEvent.order === 'ascending' ? 'ASC' : 'DESC'],
  };
}
